module.exports = new __parcel__URL__("classic-backlog-app-skeleton.tpl.4dcd1347.svg").toString();